import { omit } from 'lodash';

import { ICalculatePnbPriceForm, ICustomerQuotePart } from 'quotes/types';

interface ICalculatePnbPriceData {
  id?: number;
  price?: number;
  purchaseCost?: number;
  priceAdder?: number;
  purchaseCostAdder?: number;
  priceBase?: number;
  purchaseCostBase?: number;
}

export const mapQuotePartsCalculatePnbPricing = (
  data: ICalculatePnbPriceForm,
  selectedQuotePart: ICustomerQuotePart,
  allQuoteParts: ICustomerQuotePart[]
) => {
  let mappedData: ICalculatePnbPriceData = {};

  if (data.computedPurchaseCostBase && data.computedPurchaseCostAdder) {
    mappedData = {
      ...mappedData,
      purchaseCostBase: data.computedPurchaseCostBase,
      purchaseCostAdder: data.computedPurchaseCostAdder,
    };
  } else {
    mappedData = {
      purchaseCost: data.computedPurchaseCost,
      purchaseCostBase: null,
      purchaseCostAdder: null,
    };
  }

  if (data.priceBase && data.priceAdder) {
    mappedData = {
      ...mappedData,
      priceBase: data.priceBase,
      priceAdder: data.priceAdder,
    };
  } else {
    mappedData = {
      ...mappedData,
      price: data.price,
    };
  }

  const quotePartToUpdate = { id: selectedQuotePart.id, ...mappedData };

  if (!data.allSameBase) {
    return { quoteParts: [quotePartToUpdate] };
  }

  const allQuotePartsSameBase = allQuoteParts.filter(
    (quotePart) => quotePart.partArr?.baseIdentifier === selectedQuotePart.partArr?.baseIdentifier
  );

  if (allQuotePartsSameBase.length === 0) {
    return { quoteParts: [quotePartToUpdate] };
  }

  const quotePartsWithSameBaseToUpdate = allQuotePartsSameBase.map((quotePart) => ({
    id: quotePart.id,
    ...omit(mappedData, ['purchaseCost', 'price']),
  }));

  return {
    quoteParts: [quotePartToUpdate, ...quotePartsWithSameBaseToUpdate],
  };
};
